import React, { Component } from "react";
import { Segment, Step } from "semantic-ui-react";
import Validator from "validatorjs";
import set from "lodash/set";
import _ from "lodash";

import { AppContext } from "../../utils/context";
import request from "../../utils/request";

import GameTypes from "../../components/forms/event/GameTypes";
import General from "../../components/forms/event/General";
import NonProfit from "../../components/forms/event/NonProfit";
import Sales from "../../components/forms/event/Sales";
import Pricing from "../../components/forms/event/Pricing";
import Jackpot from "../../components/forms/event/Jackpot";
import Expenses from "../../components/forms/event/Expenses";
import Verify from "../../components/forms/event/Verify";
import ResponseMessage from "../../components/common/ResponseMessage";
import { array } from "prop-types";

function dateRangeOverlaps(a_start, a_end, b_start, b_end) {
  if (a_start <= b_start && b_start <= a_end) return true; // b starts in a
  if (a_start <= b_end   && b_end   <= a_end) return true; // b ends in a
  if (b_start <  a_start && a_end   <  b_end) return true; // a in b
  return false;
}

function multipleDateRangeOverlaps(dynamicPPs) {
  let i = 0, j = 0;
  let timeIntervals = dynamicPPs.filter(dyPP => dyPP.start != null && dyPP.end != null);

  if (timeIntervals != null && timeIntervals.length > 1)
  for (i = 0; i < timeIntervals.length - 1; i += 1) {
      for (j = i + 1; j < timeIntervals.length; j += 1) {
              if (
              dateRangeOverlaps(
                new Date(timeIntervals[i].start).getTime(), new Date(timeIntervals[i].end).getTime(),
                new Date(timeIntervals[j].start).getTime(), new Date(timeIntervals[j].end).getTime()
                  )
              ) return true;
          }
      }
 return false;
}

class EventForm extends Component {
  constructor(props, context) {
    super(props);
    this.rules = {};
    this.customMessages = {};
    this.foundValidationIssues = false;
    this.eventFormValidationMessage = "";
    let formSteps = [
      {
        key: "general",
        title: "General",
        link: true,
        onClick: () => this.handleStep("general"),
        active: true
      },
      {
        key: "games",
        title: "Game Type",
        link: true,
        onClick: () => this.handleStep("games"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      },
      {
        key: "non-profit",
        title: "Non-profit",
        link: true,
        onClick: () => this.handleStep("non-profit"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      },
      {
        key: "sales",
        title: "RSU / E-Commerce",
        link: true,
        onClick: () => this.handleStep("sales"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      },
      {
        key: "pricing",
        title: "Pricing",
        link: true,
        onClick: () => this.handleStep("pricing"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      },
      {
        key: "jackpot",
        title: "Jackpot",
        link: true,
        onClick: () => this.handleStep("jackpot"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      },
      {
        key: "expenses",
        title: "Expenses",
        link: true,
        onClick: () => this.handleStep("expenses"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      },
      {
        key: "verify",
        title: "Verify",
        link: true,
        onClick: () => this.handleStep("verify"),
        active: false,
        disabled: props && props.eventId === "create" ? true : false
      }
    ];

    this.state = {
      isLoading: true,
      step: "general",
      eventId: false,
      xhrStatus: "",
      xhrMessage: "",
      xhrEventId: false,
      validation: new Validator({}, {}),
      games: [],
      campaigns: [],
      nonProfits: [],
      subscriptionGroups: [],
      beneficiaries: [],
      jackpotScreens: [],
      pricingData: {},
      disableRSUToggle: false,
      isPPEditable: true,
      dynamicResponseArray: {},
      lastPPTablet: [],
      lastPPWeb: [],
      lastDynamicPPTablet: [],
      lastDynamicPPWeb: [],
      ecommerceEnabled: -1,
      event: {
        id: false,
        game_id: 0,
        parent_id: false,
        title: "",
        start_at: "",
        end_at: "",
        draw_at_text: "",
        nonprofit_id: 0,
        jackpot_id: 0,
        campaigns: [],
        jackpot_start: "",
        normalize_jackpot: "",
        normalize_jackpot_prize: "",
        sweetenpot: "",
        prizelimit: "",
        orderlimit: "",
        expense_flat: "",
        expense_venue_total: "",
        expense_venue_jackpot: "",
        expense_cc_percent: "",
        expense_cc_trans: "",
        is_test: 0,
        is_import_raffle: 0,
        prize_imports_enabled: 0,
        percent_prize: 0,
        percent_nonprofit: 100,
        percent_seed: 0,
        card_rank: "",
        card_suit: "",
        is_first_thread: true,
        is_hidden: 0,
        beneficiaries: [],
        beneficiaryenabled: 0,
        card_set_id: 1,
        card: "",
        content_box_right: '',
        sequential_numbering_min: '',
        sequential_numbering_max: '',
        sequentialNumbering: 0,
        event_subscription_group_id: 0,
        validateQuantity: 0,
        validatePrice: 0,
        validateDynamicQuantity: 0,
        validateDynamicPrice: 0,
        webenabled: 0,
        rsu_enabled: 1,
        shopify_enabled: -1,
        shopify_storefront: "",
        calendar_jackpot: "",
        addonEventIds: [],
        set_custom_number_range_as_default: 0
      },
      parentEvent: undefined,
      steps: formSteps,
      defaultMaxTickets: (context && context.config && context.config.max_tickets) ? context.config.max_tickets : "999",
      errorMaxTickets: '',
      maxPricePointCount: (context && context.config && context.config.max_pricepoints) ? context.config.max_pricepoints: 4,
      systemDefaultPrices: [],
      systemDefaultJackpotID: 0,
      dynamicPPTimeOverlap: false,
      NonAddOnEventList: {},
      calendarStartDateError: false
    };
  }
  async componentDidMount() {
    this.startLoading();

    // Set current event (if updating) and pricepoints
    let eid = this.props.match.params.id;
    let mainEventId = null; // Main event id for add-on events (type number | null)
    let pricepoint = undefined;
    if (eid > 0 && eid !== "create") {
      let event = await request.get(this, `api:/event/${eid}`);
      this.setEvent(event);
      pricepoint = event.prices;
      mainEventId = event.parent_id ?? null;
    }
    this.setPricePoint(pricepoint);
    let systemSettings = await request.get(this, "api:/settings/config", {});
    let events = await request.list(this, "api:/event", { limit: 1000, sort: [{ id: "start_at", desc: true }], filter_draws: 5, main_event_id: mainEventId });
    let campaigns = await request.list(this, "api:/campaign", { limit: 100, sort: [{ id: 'start_at', desc: true }], active_only: true });
    let games = await request.get(this, "api:/game", { limit: 100, sort: [{ id: 'id', desc: false }] });
    let nonprofits = await request.get(this, "api:/non-profit", {});
    let beneficiaries = await request.get(this, "api:/beneficiary", { sort: [], q: "", page: 1, limit: 0 });
    let jackpots = await request.list(this, "api:/content/jackpot-screen", { limit: 100, sort: [{ id: 'id', desc: true }], active_only: true });

    this.setSystemSettings(systemSettings);
    this.setAllEvents(events);
    this.setGames(games);
    this.setCampaigns(campaigns);
    this.setNonProfit(nonprofits);
    this.setJackpot(jackpots);
    this.setBeneficiaries(beneficiaries);
    if (this.context.config.subscription_enabled) this.setSubscriptionGroups(await request.get(this, "api:/get-subscription-groups"));
    this.doneLoading();
  }
  startLoading = () => {
    this.setState({ isLoading: true });
  };
  doneLoading = () => {
    this.setState({ isLoading: false });
  };
  setSystemSettings = systemSettings => {
    this.setState({
      systemDefaultPrices: systemSettings["general"]["defaultprices"],
      systemDefaultJackpotID: systemSettings["general"]["default_jackpot_id"]
   },  () => {

    if(this.context.config.custom_number_range_enabled && this.state.event.id == false) {
      // Set default sequential numbering range
      let data = this.state;
      data.event.sequential_numbering_min = systemSettings['hidden']['sequential_numbering_min'];
      data.event.sequential_numbering_max = systemSettings['hidden']['sequential_numbering_max'];
      set(data, 'event.sequential_numbering_min', data.event.sequential_numbering_min);
      set(data, 'event.sequential_numbering_max', data.event.sequential_numbering_max);
      this.setState(data);
    }
   });
  }
  setAllEvents = events => {
    let list = events?.data ?? {};
    list = list.filter(event => event.id !== this.state.eventId);
    this.setState({ NonAddOnEventList: list });
  }
  setPricePoint = resp => {
    const systemDefaultPrices = this.state.systemDefaultPrices; // Latest system default prices
    const contextDefaultPrices = this.context.settings.general.defaultprices; // Only updated on page reload - one state behind systemDefaultPrices
    const removeDefaultLabels = !this.context.config.pricepoint_labels_enabled;
    let pricePointsDefault = [];
    let pricePointsDynamic = [];
    let disableRSUToggle = false;
    // New Event fetching system default pricepoints
    if (!resp) {
      pricePointsDefault = systemDefaultPrices && typeof(systemDefaultPrices) === "string" ? JSON.parse(systemDefaultPrices) : JSON.parse(contextDefaultPrices);
      pricePointsDefault.forEach(ppD => {
        // set quantity to max_tickets allowed per pricepoint if it exceeds the max_tickets limit
        ppD['quantity'] = Math.min(parseInt(ppD['quantity']), parseInt(this.state.defaultMaxTickets));
        ppD['price'] = Number(ppD['price']);
        ppD['max_count'] = Number(ppD['max_count']);
        ppD['highlight'] = Number(ppD['highlight']);
        ppD['subscription'] = Number(ppD['subscription']);
        ppD['current'] = Number(ppD['current']);
        ppD['is_depleted'] = Number(ppD['is_depleted']);
        ppD['key'] = String(ppD['pp_id']);
        ppD['label'] = removeDefaultLabels ? '' : ppD['label'];
      });
      // check if pricepoint limits are enabled or custom web pricing is disabled
      if (this.context && (this.context.config.pricepoint_limits_enabled || !this.context.config.custom_web_pricing_enabled)) {
        for (let i = 0; i < pricePointsDefault.length; i++) {
          let index = i;
          let maxPricePointCount = this.state.maxPricePointCount;
          if (i >= maxPricePointCount && i < pricePointsDefault.length) {
            pricePointsDefault[index].quantity = pricePointsDefault[index - maxPricePointCount].quantity;
            pricePointsDefault[index].price = pricePointsDefault[index - maxPricePointCount].price;
            pricePointsDefault[index].max_count = pricePointsDefault[index - maxPricePointCount].max_count;
            pricePointsDefault[index].label = pricePointsDefault[index - maxPricePointCount].label;
            pricePointsDefault[index].highlight = pricePointsDefault[index - maxPricePointCount].highlight;
            pricePointsDefault[index].subscription = pricePointsDefault[index - maxPricePointCount].subscription;
            pricePointsDefault[index].current = pricePointsDefault[index - maxPricePointCount].current;
            pricePointsDefault[index].is_depleted = pricePointsDefault[index - maxPricePointCount].is_depleted;
          }
        }
      }
    } else {
      const dynamicResponseArray = resp && resp.dynamic;
      this.setState({ isPPEditable: false, dynamicResponseArray });
      let array = resp.default;
      disableRSUToggle = true;
      for (var i = 0; i < array.length; i++) {
        if (array[i].pp_id) {
          if (array[i].type === 'tablet') {
            disableRSUToggle = false;
          }
          pricePointsDefault[array[i].pp_id - 1] = {
            id: Number(array[i].id),
            pp_id: Number(array[i].pp_id),
            event_id: array[i].event_id ? Number(array[i].event_id) : this.props.match.params.id,
            type: array[i].type,
            quantity: Number(array[i].quantity),
            price: Number(array[i].price),
            highlight: Number(array[i].highlight) > 0 ? 1 : 0,
            subscription: Number(array[i].subscription) > 0 ? 1 : 0,
            max_count: Number(array[i].max_count),
            label: array[i].label,
            current: Number(array[i].current),
            is_depleted: Number(array[i].is_depleted)
          };
        }
      }
      dynamicResponseArray && dynamicResponseArray.map((value, index) => {
        let respDynamic = value.pricepoints;
        let arrayDynamic = [];
        for (var i = 0; i < respDynamic.length; i++) {
          if (respDynamic[i].pp_id) {
            arrayDynamic[respDynamic[i].pp_id - 1] = {
              id: Number(respDynamic[i].id),
              pp_id: Number(respDynamic[i].pp_id),
              event_id: respDynamic[i].event_id ? Number(respDynamic[i].event_id) : this.props.match.params.id,
              type: respDynamic[i].type,
              quantity: Number(respDynamic[i].quantity),
              price: Number(respDynamic[i].price),
              highlight: Number(respDynamic[i].highlight) > 0 ? 1 : 0,
              subscription:  0,
              max_count: Number(respDynamic[i].max_count),
              label: respDynamic[i].label,
              current: Number(respDynamic[i].current),
              is_depleted: Number(respDynamic[i].is_depleted)
            };
          }
        }
        return pricePointsDynamic.push({
          start: value.start,
          end: value.end,
          pricepoints: arrayDynamic
        });
      });
    }
    this.setState({ pricingData: { "default": pricePointsDefault, "dynamic": pricePointsDynamic }, disableRSUToggle });
  }
  setEvent = resp => {
    resp.sequential_min = this.context.config.server_generated_number_min ? this.context.config.server_generated_number_min : '';
    resp.sequential_max = this.context.config.server_generated_number_max ? this.context.config.server_generated_number_max : '';
    resp.validateQuantity = 0;
    resp.validateDynamicQuantity = 0;
    resp.validatePrice = 0;
    resp.validateDynamicPrice = 0;
    this.setState(
      {
        eventId: resp.id,
        event: resp
      }
    );

    let defaultStep = "general";
    if (typeof this.props.match.params.method !== "undefined") {
      defaultStep = this.props.match.params.method;
    }
    this.handleStep(defaultStep);
  };
  setSubscriptionGroups = resp => {
    if (!resp.data) return [];
    let subscriptionGroups = [...this.state.subscriptionGroups];
    resp.data.map((value, index) => {
      return subscriptionGroups.push({
        id: value.id,
        value: value.id,
        text: value.name,
        events: value.events
      });
    });
    this.setState({ subscriptionGroups });
  };
  setGames = resp => {
    if (!resp.data) return [];
    let games = [];
    let event = { ...this.state.event };
    resp.data.map((value, index) => {
      if (event.game_id === 0 && resp.data.length === 1) {
        event.game_id = value.id;
        event.percent_prize = value.settings.percent_prize;
        event.percent_seed = value.settings.percent_seed;
        event.percent_nonprofit = value.settings.percent_nonprofit;
        if (+value.id === 3) {
          event.card_rank = value.settings.card_rank;
          event.card_suit = value.settings.card_suit;
        }
      }
      games[value.id] = value;
      games[value.id].text = value.title;
      return games[value.id].value = +value.id;
    });
    this.setState({ games: games, event: event });
  };
  setCampaigns = resp => {
    if (!resp.data) return [];
    let campaigns = [...this.state.campaigns];
    resp.data.map((value, index) => {
      return campaigns.push({
        id: value.id,
        value: +value.id,
        text: value.title
      });
    });
    this.setState({ campaigns });
  };
  setNonProfit = resp => {
    if (!resp.data) return [];
    let nonProfits = [...this.state.nonProfits];
    let event = { ...this.state.event };
    resp.data.map((value, index) => {
      if (event.nonprofit_id === 0 && resp.data.length === 1)
        event.nonprofit_id = value.id;
      return nonProfits.push({
        id: value.id,
        value: value.id,
        text: value.name
      });
    });
    this.setState({ nonProfits, event: event });
  };
  setBeneficiaries = resp => {
    if (!resp.data) return [];
    let beneficiaries = [...this.state.beneficiaries];
    resp.data.map((value, index) => {
      return beneficiaries.push({
        id: value.id,
        value: value.id,
        text: value.name
      });
    });
    this.setState({ beneficiaries });
  };
  setJackpot = resp => {
    if (!resp.data) return [];

    let jackpotScreens = [...this.state.jackpotScreens];
    resp.data.map((value, index) => {
      return jackpotScreens.push({
        id: value.id,
        value: value.id,
        text: value.name,
      });
    });

    let event = { ...this.state.event };
    // Set default
    event.jackpot_id = event.jackpot_id ? event.jackpot_id : Number(this.state.systemDefaultJackpotID);

    this.setState({
        jackpotScreens,
        event
     });
  };
  setExpenses = resp => {
    if (!resp.data) return [];
    let expenses = [...this.state.expenses];
    resp.data.map((value, index) => {
      return expenses.push({
        id: value.id,
        value: value.id,
        text: value.name,
      });
    });
    this.setState({ expenses });
  };
  // Add new Dynamic Pricepoints
  addPricing = () => {
    let systemDefaultPrices = this.state.systemDefaultPrices; // Latest system default prices
    let contextDefaultPrices = this.context.settings.general.defaultprices; // Only updated on page reload - one state behind systemDefaultPrices
    let pricingData = { ...this.state.pricingData };
    let length = pricingData['dynamic'].length;
    var d = new Date();
    var mm = d.getMonth() + 1;
    var dd = d.getDate();
    var yy = d.getFullYear();
    var timeString = new Date().toLocaleTimeString();
    const [time, modifier] = timeString.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    let pricePointsDynamicDefault = systemDefaultPrices ? JSON.parse(systemDefaultPrices) : JSON.parse(contextDefaultPrices);
    pricePointsDynamicDefault.forEach(ppD => {
      // set quantity to max_tickets allowed per pricepoint if it exceeds the max_tickets limit
      ppD['quantity'] = Math.min(parseInt(ppD['quantity']), parseInt(this.state.defaultMaxTickets));
      ppD['price'] = Number(ppD['price']);
      ppD['max_count'] = Number(ppD['max_count']);
      ppD['highlight'] = Number(ppD['highlight']);
      ppD['subscription'] = 0;
      ppD['current'] = Number(ppD['current']);
      ppD['is_depleted'] = Number(ppD['is_depleted']);
      ppD['key'] = `dynamic_${length}_${ppD['pp_id']}`;
    });
    // check if pricepoint limits are enabled or custom web pricing is disabled
    if (this.context && (this.context.config.pricepoint_limits_enabled || !this.context.config.custom_web_pricing_enabled)) {
      for (let i = 0; i < pricePointsDynamicDefault.length; i++) {
        let index = i;
        if (i >= this.state.maxPricePointCount && i < pricePointsDynamicDefault.length) {
          pricePointsDynamicDefault[index].quantity = pricePointsDynamicDefault[index - this.state.maxPricePointCount].quantity;
          pricePointsDynamicDefault[index].price = pricePointsDynamicDefault[index - this.state.maxPricePointCount].price;
          pricePointsDynamicDefault[index].max_count = pricePointsDynamicDefault[index - this.state.maxPricePointCount].max_count;
          pricePointsDynamicDefault[index].label = pricePointsDynamicDefault[index - this.state.maxPricePointCount].label;
          pricePointsDynamicDefault[index].highlight = pricePointsDynamicDefault[index - this.state.maxPricePointCount].highlight;
          pricePointsDynamicDefault[index].subscription = 0;
          pricePointsDynamicDefault[index].current = pricePointsDynamicDefault[index - this.state.maxPricePointCount].current;
          pricePointsDynamicDefault[index].is_depleted = pricePointsDynamicDefault[index - this.state.maxPricePointCount].is_depleted;
        }
      }
    }
    pricingData['dynamic'][length] = {
      start: yy + `-` + mm + `-` + dd + ` ${hours}:${minutes}`,
      end: yy + `-` + mm + `-` + dd + ` ${+hours + 1}:${minutes}`,
      pricepoints: pricePointsDynamicDefault
    }

    this.setState({ pricingData });
  };
  // Delete recently added Dynamic Pricepoints
  removePricing = id => {
    let pricingData = { ...this.state.pricingData };
    pricingData['dynamic'].splice(id, 1);
    this.setState({ pricingData });
  };
  // Delete Default Pricepoint Set
  deletePricepoint = (id, device) => { // handle + and - pp
    let systemDefaultPrices = this.state.systemDefaultPrices; // Latest system default prices
    let contextDefaultPrices = this.context.settings.general.defaultprices; // Only updated on page reload - one state behind systemDefaultPrices
    let pricingData = { ...this.state.pricingData };
    let lastPPTablet = this.state.lastPPTablet;
    let lastPPWeb = this.state.lastPPWeb;
    let pricepoints = pricingData['default'];
    for (var i = 0; i < pricepoints.length / 2; i++) {
      if (device === "tablet") {
        if (pricepoints[i] === undefined && id === i) { // add
          pricepoints[i] = systemDefaultPrices[i] ? JSON.parse(systemDefaultPrices)[i] : JSON.parse(contextDefaultPrices)[i]; // add tablet pp
          pricepoints[i]['key'] = `${id + 1}`;
          // set quantity to max_tickets allowed per pricepoint if it exceeds the max_tickets limit
          pricepoints[i]['quantity'] = Math.min(parseInt(pricepoints[i]['quantity']), parseInt(this.state.defaultMaxTickets));

          if (!this.context.config.custom_web_pricing_enabled || this.context.config.pricepoint_limits_enabled) { // custom web prices turned off or pricepoint limits enabled
            // add web pp
            pricepoints[i + this.state.maxPricePointCount] = systemDefaultPrices[i + this.state.maxPricePointCount] ? JSON.parse(systemDefaultPrices)[i + this.state.maxPricePointCount] : JSON.parse(contextDefaultPrices)[i + this.state.maxPricePointCount];
            pricepoints[i + this.state.maxPricePointCount]['key'] = `${id + this.state.maxPricePointCount + 1}`;
            // set quantity to max_tickets allowed per pricepoint if it exceeds the max_tickets limit
            pricepoints[i + this.state.maxPricePointCount]['quantity'] = Math.min(parseInt(pricepoints[i + this.state.maxPricePointCount]['quantity']), parseInt(this.state.defaultMaxTickets));
          }
        }
        else if (pricepoints[i] !== undefined && pricepoints[i]['key'] === `${id + 1}`) { // delete
          delete pricepoints[pricepoints.indexOf(pricepoints[i])]; // delete tablet pp
          if (!this.context.config.custom_web_pricing_enabled || this.context.config.pricepoint_limits_enabled) { // custom web prices turned off or pricepoint limits enabled
            delete pricepoints[pricepoints.indexOf(pricepoints[i + this.state.maxPricePointCount])]; // delete web pp
          }
        }
      }
      if (device === "web") {
        if (pricepoints[i + this.state.maxPricePointCount] === undefined && id === i) {
          pricepoints[i + this.state.maxPricePointCount] = systemDefaultPrices[i + this.state.maxPricePointCount] ? JSON.parse(systemDefaultPrices)[i + this.state.maxPricePointCount] : JSON.parse(contextDefaultPrices)[i + this.state.maxPricePointCount];
          pricepoints[i + this.state.maxPricePointCount]['key'] = `${this.state.maxPricePointCount + id + 1}`;
          // set quantity to max_tickets allowed per pricepoint if it exceeds the max_tickets limit
          pricepoints[i + this.state.maxPricePointCount]['quantity'] = Math.min(parseInt(pricepoints[i + this.state.maxPricePointCount]['quantity']), parseInt(this.state.defaultMaxTickets));
        }
        else if (pricepoints[i + this.state.maxPricePointCount] !== undefined && pricepoints[i + this.state.maxPricePointCount]['key'] === `${this.state.maxPricePointCount + id + 1}`) {
          delete pricepoints[pricepoints.indexOf(pricepoints[i + this.state.maxPricePointCount])];
        }
      }
      //Disable tablet last PP delete button
      let arrayTablet = pricepoints.filter(function (el) {
        return el['type'] === 'tablet' && el != null;
      });
      if (lastPPTablet.length > 0) {
        document.getElementById(`delete_${lastPPTablet[0]['pp_id']}`).removeAttribute("disabled");
      }
      if (arrayTablet.length === 1) {
        document.getElementById(`delete_${arrayTablet[0]['pp_id']}`).setAttribute("disabled", "disabled");
        lastPPTablet = arrayTablet;
      }
      //Disable web last PP delete button
      let arrayWeb = pricepoints.filter(function (el) {
        return el['type'] === 'web' && el != null;
      });
      if (lastPPWeb.length > 0 && this.context.config.custom_web_pricing_enabled) {
        document.getElementById(`delete_${lastPPWeb[0]['pp_id']}`).removeAttribute("disabled");
      }
      if (arrayWeb.length === 1 && this.context.config.custom_web_pricing_enabled) {
        document.getElementById(`delete_${arrayWeb[0]['pp_id']}`).setAttribute("disabled", "disabled");
        lastPPWeb = arrayWeb;
      }
    }
    this.setState({ pricingData, lastPPTablet, lastPPWeb });
  }
  //Delete Dynamic Pricepoint Set
  deletePricepointSet = (index, id, device) => {
    let systemDefaultPrices = this.state.systemDefaultPrices; // Latest system default prices
    let contextDefaultPrices = this.context.settings.general.defaultprices; // Only updated on page reload - one state behind systemDefaultPrices
    let pricingData = { ...this.state.pricingData };
    let lastDynamicPPTablet = this.state.lastDynamicPPTablet;
    let lastDynamicPPWeb = this.state.lastDynamicPPWeb;
    let pricepoints = pricingData['dynamic'][index]['pricepoints'];
    for (var i = 0; i < pricepoints.length; i++) {
      if (device === "tablet") {
        if (pricepoints[i] === undefined && id === i) { // add
          pricepoints[i] = systemDefaultPrices[i] ? JSON.parse(systemDefaultPrices)[i] : JSON.parse(contextDefaultPrices)[i];
          pricepoints[i]['key'] = `dynamic_${index}_${id + 1}`;

          if (!this.context.config.custom_web_pricing_enabled || this.context.config.pricepoint_limits_enabled) { // custom web prices turned off or pricepoint limits enabled
            // add dynamic web pp
            pricepoints[i + this.state.maxPricePointCount] = systemDefaultPrices[i + this.state.maxPricePointCount] ? JSON.parse(systemDefaultPrices)[i + this.state.maxPricePointCount] : JSON.parse(contextDefaultPrices)[i + this.state.maxPricePointCount];
            pricepoints[i + this.state.maxPricePointCount]['key'] = `dynamic_${index}_${id + this.state.maxPricePointCount + 1}`;
            // set quantity to max_tickets allowed per pricepoint if it exceeds the max_tickets limit
            pricepoints[i + this.state.maxPricePointCount]['quantity'] = Math.min(parseInt(pricepoints[i + this.state.maxPricePointCount]['quantity']), parseInt(this.state.defaultMaxTickets));
          }
        }
        else if (pricepoints[i] !== undefined && pricepoints[i]['key'] === `dynamic_${index}_${id + 1}`) { // delete
          delete pricepoints[pricepoints.indexOf(pricepoints[i])];
          if (!this.context.config.custom_web_pricing_enabled || this.context.config.pricepoint_limits_enabled) { // custom web prices turned off or pricepoint limits enabled
            delete pricepoints[pricepoints.indexOf(pricepoints[i + this.state.maxPricePointCount])];
          }
        }
      }
      if (device === "web") {
        if (pricepoints[i + this.state.maxPricePointCount] === undefined && id === i) {
          pricepoints[i + this.state.maxPricePointCount] = systemDefaultPrices[i + this.state.maxPricePointCount] ? JSON.parse(systemDefaultPrices)[i + this.state.maxPricePointCount] : JSON.parse(contextDefaultPrices)[i + this.state.maxPricePointCount];
          pricepoints[i + this.state.maxPricePointCount]['key'] = `dynamic_${index}_${this.state.maxPricePointCount + id + 1}`;
        }
        else if (pricepoints[i + this.state.maxPricePointCount] !== undefined && pricepoints[i + this.state.maxPricePointCount]['key'] === `dynamic_${index}_${this.state.maxPricePointCount + id + 1}`) {
          delete pricepoints[pricepoints.indexOf(pricepoints[i + this.state.maxPricePointCount])];
        }
      }
      //Disable tablet last PP delete button
      let arrayTablet = pricepoints.filter(function (el) {
        return el['type'] === 'tablet' && el != null;
      });
      if (lastDynamicPPTablet.length > 0) {
        document.getElementById(`delete_dynamic_${index}_${lastDynamicPPTablet[0]['pp_id']}`).removeAttribute("disabled");
      }
      if (arrayTablet.length === 1) {
        document.getElementById(`delete_dynamic_${index}_${arrayTablet[0]['pp_id']}`).setAttribute("disabled", "disabled");
        lastDynamicPPTablet = arrayTablet;
      }
      //Disable web last PP delete button
      let arrayWeb = pricepoints.filter(function (el) {
        return el['type'] === 'web' && el != null;
      });
      if (lastDynamicPPWeb.length > 0 && this.context.config.custom_web_pricing_enabled) {
        document.getElementById(`delete_dynamic_${index}_${lastDynamicPPWeb[0]['pp_id']}`).removeAttribute("disabled");
      }
      if (arrayWeb.length === 1 && this.context.config.custom_web_pricing_enabled) {
        document.getElementById(`delete_dynamic_${index}_${arrayWeb[0]['pp_id']}`).setAttribute("disabled", "disabled");
        lastDynamicPPWeb = arrayWeb;
      }
    }
    this.setState({ pricingData, lastDynamicPPTablet, lastDynamicPPWeb });
  }
  handleRules = (obj, msg = {}) => {
    this.rules = obj;
    this.customMessages = msg;
  };
  handleChange = (e, { name, value }) => {
    let data = this.state;

    // General tab fields
    if (name === "event.is_import_raffle") {
        value = +!data.event.is_import_raffle;
        if (data.event.game_id == 4) {
          set(data, "event.game_id", 0);
        }
    }

    if (name === "event.prize_imports_enabled") {
        value = +!data.event.prize_imports_enabled;
    }
    if (name === "event.is_test") {
        value = +!data.event.is_test;
    }
    if (name === "event.is_hidden" && +data.event.is_hidden === 1) {
        value = "0";
    }
    if (name === "event.set_custom_number_range_as_default") {
      value = +!data.event.set_custom_number_range_as_default;
    }
    // Game Type tab fields
    if (name === "event.game_id") {
      set(data, "event.percent_prize", data.games[+value].settings.percent_prize);
      set(data, "event.percent_seed", data.games[+value].settings.percent_seed);
      set(data, "event.percent_nonprofit", data.games[+value].settings.percent_nonprofit);
    }
    if (name === "event.card_set_id" && +value === 3) {
      set(data, "event.card_set_id", data.event.card_set_id);
    }
    if (name === "event.card" && data.event.game_id === 3) {
      set(data, "event.card", value);
      set(data, "event.card_rank", value ? value.rank : null);
      set(data, "event.card_suit", value ? value.suit : null);
    }
    if (name === "event.calendar_jackpot") {
        if (isNaN(value) || value === "") {
          value = "";
        } else {
          value = Math.max(0, parseInt(value));
        }
    }
    if (name === "event.parent_id") {
        let parentEvent = _.find(this.state.NonAddOnEventList, { id: value }) ?? {};
        set(data, "event.rsu_enabled", parentEvent?.rsu_enabled ?? data.event.rsu_enabled);
        set(data, "event.webenabled", parentEvent.webenabled ?? data.event.webenabled);
        set(data, "event.shopify_enabled", parentEvent.shopify_enabled ?? data.event.shopify_enabled);
        set(data, "event.shopify_storefront", parentEvent.shopify_storefront ?? data.event.shopify_storefront);
        set(data, "ecommerceEnabled", +(parentEvent.webenabled || parentEvent.shopify_enabled) ?? data.ecommerceEnabled);
        set(data, "parentEvent", value ? parentEvent : undefined);
    }

    if (name === "event.subscription_group_id") {
      set(data, "event.subscription_group_id", value);
    }
    // Non-profit tab fields
    if (name === "event.beneficiaryenabled") {
      value = +!data.event.beneficiaryenabled;
      if (value !== 1) data.event.beneficiaries = [];
    }

    // Sales tab fields
    if (name === "ecommerceEnabled") { // Event-level ecommerce flag
      value = value === 0 ? 1 : 0;
      if (value < 1) {
        data.event.shopify_enabled = 0;
        data.event.webenabled = 0;
        data.event.shopify_storefront = "";
      }
    }
    // Radial group - only one should be active
    if (name === "ecommercePlatform") {
      if (value === "bump-shopify") {
        data.event.shopify_enabled = 1;
        data.event.webenabled = 0;
      } else if (value === "bump-ecommerce") {
        data.event.webenabled = 1;
        data.event.shopify_enabled = 0;
        data.event.shopify_storefront = "";
      } else {
        data.event.shopify_enabled = 0;
        data.event.webenabled = 0;
        data.event.shopify_storefront = "";
      }
    }
    if (name === "event.rsu_enabled") { // Event-level rsu flag
        value = +!data.event.rsu_enabled;
    }

    //Pricing tab fields
    if (name.indexOf("pricingData") >= 0) {
      let nameValues = name.split('.');
      const pricingIndex = name.match(/\.\d\./g);
      let originalText = pricingIndex[pricingIndex.length - 1];
      const pricepointIndex = parseInt(originalText.slice(1,-1));
      originalText = originalText + nameValues[nameValues.length - 1]; //adding last value to text to ensure exact match when replacing below
      const matchingPricePointIndex = data.event.rsu_enabled ? pricepointIndex + this.context.config.max_pricepoints : pricepointIndex - this.context.config.max_pricepoints;
      const newText = originalText.replace(pricepointIndex, matchingPricePointIndex.toString());
      const name2 = (name.indexOf('start') < 1 && name.indexOf('end') < 1) ? name.replace(new RegExp(originalText + '$'), newText) : null;
      // dynamic pp cards
      if (name.indexOf("dynamic") >= 0) {
        if (name.indexOf('quantity') >= 0) {
          data.event.validateDynamicQuantity = value;
          value = Math.max(1, parseInt(value));
          // max_tickets setting check
          data.errorMaxTickets = '';
          if (parseInt(value) > parseInt(data.defaultMaxTickets)) {
            value = parseInt(data.defaultMaxTickets);
            data.errorMaxTickets = `The maximum quantity for this pricepoint is ${data.defaultMaxTickets}. If you do not provide a value ${data.defaultMaxTickets} or below, then the quantity is automatically set to ${data.defaultMaxTickets}.`;
          }
        }
        if (name.indexOf('price') >= 0 && !(name.indexOf('quantity') >= 0 || name.indexOf('label') >= 0 || name.indexOf('max_count') >= 0 || name.indexOf('highlight') >= 0)) {
          data.event.validateDynamicPrice = value;
          value = Math.max(1, parseInt(value));
        }
      } else {
        // default pp cards
        if (name.indexOf('quantity') >= 0) {
          data.event.validateQuantity = value;
          value = Math.max(1, parseInt(value));
          // max_tickets setting check
          data.errorMaxTickets = '';
          if (parseInt(value) > parseInt(data.defaultMaxTickets)) {
            value = parseInt(data.defaultMaxTickets);
            data.errorMaxTickets = `The maximum quantity for this pricepoint is ${data.defaultMaxTickets}. If you do not provide a value ${data.defaultMaxTickets} or below, then the quantity is automatically set to ${data.defaultMaxTickets}.`;
          }
        }
        if (name.indexOf('price') >= 0 && !(name.indexOf('quantity') >= 0 || name.indexOf('label') >= 0 || name.indexOf('max_count') >= 0 || name.indexOf('highlight') >= 0)) {
          data.event.validatePrice = value;
          value = Math.max(1, parseInt(value));
        }
      }
      if (name.indexOf('max_count') >= 0) value = parseInt(value);
      if (name.indexOf('highlight') >= 0) value = value === 1 ? 0 : 1;
      if (name.indexOf('subscription') >= 0) value = value === 1 ? 0 : 1;
      if (name.indexOf("dynamic") >= 0 && (name.indexOf("start") >= 0 || name.indexOf("end") >= 0) && value) {
        const [date, time, modifier] = value.split(' ');
        let [hours, minutes] = time.split(':');
        if (modifier === 'PM') {
          hours = parseInt(hours, 10) + 12;
        }
        value = `${date} ${hours}:${minutes}`;
      }

      if (matchingPricePointIndex <= this.state.pricingData.default.length
        && !this.context.config.custom_web_pricing_enabled && name2 !== null) {
        set(data, name2, value);
      }
    }

    // Jackpot tab fields
    if (name === "event.jackpot_start" || name === "event.sweetenpot" || name === "event.prizelimit" || name === "event.orderlimit") {
      if (isNaN(value) || value === "") {
        value = "";
      } else {
        value = Math.max(0, parseInt(value));
      }
    }
    if (name === "event.normalize_jackpot" && +data.event.normalize_jackpot === 1) {
      value = "0";
    }
    if (name === "event.normalize_jackpot_prize" && +data.event.normalize_jackpot_prize === 1) {
      value = "0";
    }

    // Expenses tab fields
    if (name === "event.expense_flat" || name === "event.expense_cc_percent" || name === "event.expense_cc_trans") {
      if (value !== "") value = parseFloat(value) > 100 ? 100 : (parseFloat(value) < 0 ? 0.00 : value);
    }
    if (name === "event.expense_venue_jackpot" || name === "event.expense_venue_total") {
      if (value !== "") value = parseFloat(value) < 0 ? 0.00 : value;
    }

    // set the values to form variables
    set(data, name, value);

    // update state
    this.setState(data, this.calculatePercent);
  };
  calculatePercent = () => {
    let event = { ...this.state.event };
    // Reset values for merchandise raffle
    if (+event.game_id === 2) {
      event.percent_prize = 0;
      event.percent_seed = 0;
    }
    // Reset values for split the pot raffle
    if (+event.game_id === 1) {
      let percentPrize = +event.percent_prize + +event.percent_seed;
      event.percent_prize = percentPrize > 100 ? 100 : (percentPrize < 0 ? 0 : percentPrize);
      event.percent_seed = 0;
    }
    let percentNonProfit = 100 - (+event.percent_prize) - (+event.percent_seed);
    event.percent_nonprofit = percentNonProfit < 0 ? 0 : (percentNonProfit > 100 ? 100 : percentNonProfit);
    this.setState({ event });
  }
  handleCampaigns = (e, { name, value }) => {
    let event = { ...this.state.event };
    let campaigns = event.campaigns;
    const index = campaigns.indexOf(value);
    if (index > -1) {
      campaigns.splice(index, 1);
    } else {
      campaigns.push(value);
    }
    event.campaigns = campaigns;
    this.setState({ event });
  };
  handleSubmit = () => {
    this.setState({ xhrStatus: "", xhrMessage: "", isLoading: true });

    let event = this.state.event;

    if (event.game_id === 3) event.parent_id = false; // CTA events must not be addons
    if (event.game_id === 4) event.sweetenpot = ""; // Calendar events must not support sweeten pot
    if (event.is_import_raffle > 0) { // set default values for import raffles
        event.rsu_enabled = 0;
        event.webenabled = 0;
        event.shopify_enabled = 0;
        event.prize_imports_enabled = 0;
        event.sweetenpot = "";
        event.prizelimit = "";
        event.orderlimit = "";
        event.jackpot_start = "";
        event.expense_flat = "";
        event.expense_venue_total = "";
        event.expense_venue_jackpot = "";
        event.expense_cc_percent = "";
        event.expense_cc_trans = "";
    }

    var originalResponse = this.state.pricingData;

    //Filter to remove deleted default pricepoints
    var filteredDefault = originalResponse['default'].filter(function (el) {
      return el != null;
    });
    originalResponse['default'] = filteredDefault;

    //Filter to remove deleted dynamic pricepoints
    originalResponse['dynamic'].forEach(dynamic => {
      var filteredDynamic = dynamic['pricepoints'].filter(function (el) {
        return el != null;
      });
      dynamic['pricepoints'] = filteredDynamic;
    });

    // BE expects prices array
    event.prices = originalResponse;

    let req;
    if (event.id > 0) {
      req = request.put(this, `api:/event/${event.id}`, event, this.handleXhrMessage);
    } else {
      req = request.post(this, "api:/event", event, this.handleXhrMessage);
    }
    req.then(resp => {
      if (+resp.id > 0) {
        let history = this.props.history;
        let url = "/events";
        history.replace(url);
      }
    });
  };
  handleXhrMessage = xhr => {
    if (xhr.success) return null;
    this.setState({
      isLoading: false,
      xhrEventId: xhr.id ? xhr.id : false,
      xhrStatus: xhr.success ? "success" : "error",
      xhrMessage: xhr.message
    });
  };
  updateWinningCard = (card) => {
    const { event } = this.state;
    event.card = card;
    this.setState({ event: event });
  }
  handleStep = index => {
    const { steps, event, errorMaxTickets, ecommerceEnabled, pricingData, subscriptionGroups } = this.state;
    const { settings, config } = this.context;
    let { percent_nonprofit,
      percent_prize,
      percent_seed,
      expense_venue_jackpot,
      expense_venue_total,
      beneficiaryenabled,
      beneficiaries,
      shopify_enabled,
      parent_id,
      event_subscription_group_id,
      is_import_raffle } = this.state.event;

    let errorMaxTicketsMessage = errorMaxTickets;
    if (errorMaxTicketsMessage !== "") errorMaxTicketsMessage = "";

    if (index === "verify") { // verify tab validation(s)
      var diff = Math.floor((Date.parse(new Date(event.start_at)) - Date.parse(new Date())) / 86400000); // convert to no of days (24 * 60 * 60 * 1000)
      this.setState({
        dynamicPPTimeOverlap: multipleDateRangeOverlaps(pricingData['dynamic']) ? true : false, // check if dynamic pp time ranges overlap
        calendarStartDateError: event.game_id === 4 && !event.id && diff < -1 ? true : false // set error if calendar start date provided is in the past
      });
    }

    // Event-creation only - Check shopify config enabled and if yes, set state for shopify_enabled
    if (this.context.config.web_sales_enabled && ecommerceEnabled < 0 && shopify_enabled < 0 && !is_import_raffle) {
      if (this.context.settings.shopify_enabled) {
        this.handleChange(null, {name: "ecommercePlatform", value: "bump-shopify"});
        this.handleChange(null, {name: "ecommerceEnabled", value: 0});
      } else {
        this.handleChange(null, {name: "ecommercePlatform", value: "bump-ecommerce"});
        this.handleChange(null, {name: "ecommerceEnabled", value: 0});
      }
    }
    // Set event-level shopify enabled to 0 if tenant-level webenabled and shopify_enabled turned off
    if ((this.context.config.web_sales_enabled !== undefined && this.context.settings.shopify_enabled !== undefined) &&
      (!this.context.config.web_sales_enabled && !this.context.settings.shopify_enabled)) {
      this.handleChange(null, {name: "ecommercePlatform", value: ""});
    }

    // no double quotes for event title
    Validator.register('no_double_quotes', (value, requirement, attribute) => {
      return !value.includes('"');
    }, 'The event title field must not contain double quotes.');

    Validator.register('no_back_slash', (value, requirement, attribute) => {
      return !value.includes('\\');
    }, 'The event title field must not contain back slash.');

    // requirement parameter defaults to null
    Validator.register('prize_split', function (value, requirement, attribute) {
      return +percent_nonprofit + +percent_prize + +percent_seed === 100;
    }, 'The prize distribution percentages must equal 100.');

    Validator.register('cta_game_not_for_subscription', function (value, requirement, attribute) {
      if (event.game_id == 3 && event_subscription_group_id > 0) {
        return false;
      } else {
        return true;
      }
    }, 'Subscription Event Currently not support Chase The Ace Game');

    Validator.register('custom_range_requires_min_and_max', function (value, requirement, attribute) {
      if (
          (+event.sequential_numbering_min != 0 && +event.sequential_numbering_max == 0) ||
          (+event.sequential_numbering_min == 0 && +event.sequential_numbering_max != 0)
      ) {
        return false;
      }

      return true;
    }, 'The custom number range requires both min and max numbers.');

    Validator.register('invalid_custom_number_range', function (value, requirement, attribute) {
      if (
          (+event.sequential_numbering_min != 0 && +event.sequential_numbering_min >= +event.sequential_numbering_max)
      ) {
        return false;
      }

      return true;
    }, 'The custom number range is invalid - the last number must be larger than the first number.');

    Validator.register('exceeds_number_assignment_limit', function (value, requirement, attribute) {
      if (
          +config.number_assignment_limit > 0 && (+event.sequential_numbering_max - +event.sequential_numbering_min + 1 > +config.number_assignment_limit )
      ) {
        return false;
      }

      return true;
    }, 'The custom number range is invalid - it exceeds the number assignment limit of ' + config.number_assignment_limit);

    Validator.register('max_ticket_number_exceeded', function (value, requirement, attribute) {
      if (
          (+event.sequential_numbering_max > settings.hidden.max_ticket_number)
      ) {
        return false;
      }

      return true;
    }, 'Max ticket number exceeded - the largest number cannot be greater than ' + settings.hidden.max_ticket_number);

    Validator.register('not_same_as_main_event_group', function (value, requirement, attribute) {
      if (event_subscription_group_id === false || parent_id === false) {
        return true;
      }

      const subscriptionGroup = subscriptionGroups.find(group => group.id === event_subscription_group_id);
      if (subscriptionGroup === undefined) {
        return true;
      }

      const subscriptionEventLists = subscriptionGroup.events.map(event => event.id);
      if (subscriptionEventLists.length === 0) {
        return true;
      }

      if (!subscriptionEventLists.includes(parent_id)) {
        return true;
      }

      return false;
    }, 'Addon Event Subscription Group can not be same as Main Event Subscription Group');


    // Non-profit tab beneficiaries validation
    Validator.register('beneficiary_selected', function (value, requirement, attribute) {
      if (beneficiaryenabled > 0) {
        return beneficiaries.length > 0;
      } else {
        return true;
      }
    }, 'You enabled beneficiaries for this event, please select one or more beneficiaries from the list.');

    // Pricing tab validation - below validation can be removed once flatpickr supports allowClearing flag
    if (config.dynamic_pricing_enabled && pricingData?.dynamic?.length > 0) { // check if dynamic pricing enabled and at-least one dynamic pricing defined
        for (let dynamicPricing of pricingData.dynamic) {
          if (dynamicPricing.start === "" || dynamicPricing.end === "") { // check if null start or end date
            this.foundValidationIssues = true;
            this.eventFormValidationMessage = "Dynamic Pricing date(s) cannot be empty";
            break;
        } else if (Date.parse(dynamicPricing.end) < Date.parse(dynamicPricing.start) ||
                   Date.parse(dynamicPricing.end) == Date.parse(dynamicPricing.start)) {
            this.foundValidationIssues = true;
            this.eventFormValidationMessage = "The End Date must come after the Start Date";
            break;
        } else {
            this.foundValidationIssues = false;
            this.eventFormValidationMessage = "";
        }
        }
    } else {
      this.foundValidationIssues = false;
      this.eventFormValidationMessage = "";
    }

    // Jackpot tab fixed expenses validation
    Validator.register('expenses_venue', function (value, requirement, attribute) {
      return parseFloat(expense_venue_total) <= parseFloat(expense_venue_jackpot);
    }, 'The subtract amount should not exceed the venue jackpot amount.');

    //Safari and IE does not support yyyy-mm-dd format so using yyyy/mm/dd in the FE
    event.start_at = event.start_at.replace(/-/g, "/");
    event.end_at = event.end_at.replace(/-/g, "/");

    // code block for validation
    let validation = new Validator(event, this.rules, this.customMessages);
    this.setState({ validation });

    // skip sales tab if turned off
    if (index === 'sales' && event.is_import_raffle) index = 'pricing';

    if (validation.passes() && !this.foundValidationIssues) {
      if (index === "submit") {
        return this.handleSubmit();
      }
      steps.map((value, key) => {
        steps[key].active = false;
        if (value.key === index) {
          steps[key].active = true
          steps[key].disabled = false;
        }
        return steps[key];
      });

      // handle actual form submission here
      this.setState({
        step: index
      });
    }
  };
  showStep = step => {
    switch (step) {
      default:
        return (
          <GameTypes
            games={this.state.games}
            loading={this.state.isLoading}
            valid={this.state.validation}
            event={this.state.event}
            language={this.context.language}
            config={this.context.config}
            NonAddOnEventList={this.state.NonAddOnEventList}
            subscriptionEnabled={this.context.config.subscription_enabled}
            subscriptionGroups={this.state.subscriptionGroups}
            handleChange={this.handleChange}
            handleStep={this.handleStep}
            setRules={this.handleRules}
          />
        );
      case "general":
        return (
          <General
            campaigns={this.state.campaigns}
            loading={this.state.isLoading}
            valid={this.state.validation}
            values={this.state.event}
            config={this.context.config}
            nonProfits={this.state.nonProfits}
            handleCampaigns={this.handleCampaigns}
            handleChange={this.handleChange}
            handleStep={this.handleStep}
            setRules={this.handleRules}
          />
        );
      case "non-profit":
        return (
          <NonProfit
            nonProfits={this.state.nonProfits}
            valid={this.state.validation}
            values={this.state.event}
            beneficiaries={this.state.beneficiaries}
            beneficiary_enabled={this.context.config.beneficiary_enabled}
            handleChange={this.handleChange}
            handleStep={this.handleStep}
            setRules={this.handleRules}
          />
        );
        case "sales":
        return (
          <Sales
            valid={this.state.validation}
            event={this.state.event}
            parentEvent={this.state.parentEvent}
            webConfigEnabled={this.context.config.web_sales_enabled} // Tenant-level ecommerce flag
            ecommerceEnabled={this.state.ecommerceEnabled} // Event-level ecommerce flag
            disableRSUToggle={this.state.disableRSUToggle}
            shopifyConfigEnabled={this.context.settings.shopify_enabled}
            shopifyStoreFronts={this.context.settings.shopify_storefronts}
            handleChange={this.handleChange}
            handleStep={this.handleStep}
            setRules={this.handleRules}
          />
        );
      case "pricing":
        let lastPPData = {
          'lastPPTablet' : this.state.lastPPTablet,
          'lastPPWeb': this.state.lastPPWeb,
          'lastDynamicPPTablet': this.state.lastDynamicPPTablet,
          'lastDynamicPPWeb': this.state.lastDynamicPPWeb
        }
        let hasOneValidDefaultPrice = JSON.parse(this.state.systemDefaultPrices).find(pp => pp.quantity > 0 && pp.price > 0);
        return (
          <Pricing
            valid={this.state.validation}
            values={this.state.event}
            pricingData={this.state.pricingData}
            maxPricePointCount={this.state.maxPricePointCount}
            isPPEditable={this.state.isPPEditable}
            dynamicResponseArrayLength={this.state.dynamicResponseArray.length}
            eventId={this.state.eventId}
            deletedIndex={this.state.deletedIndex}
            deletedPP={this.state.deletedPP}
            customWebPricingEnabled={this.context.config.custom_web_pricing_enabled} //TODO: check here
            pricepointLabelsEnabled={this.context.config.pricepoint_labels_enabled}
            pricepointLimitsEnabled={this.context.config.pricepoint_limits_enabled}
            dynamicPricingEnabled={this.context.config.dynamic_pricing_enabled}
            subscriptionEnabled={this.context.config.subscription_enabled}
            errorMaxTickets={this.state.errorMaxTickets}
            eventFormValidationMessage={this.eventFormValidationMessage}
            lastPPData={lastPPData}
            hasOneValidDefaultPrice={hasOneValidDefaultPrice}
            addPrice={this.addPricing}
            handleChange={this.handleChange}
            handleStep={this.handleStep}
            removePrice={this.removePricing}
            deletePricepoint={this.deletePricepoint}
            deletePricepointSet={this.deletePricepointSet}
            setRules={this.handleRules}
          />
        );
      case "jackpot":
        return (
          <Jackpot
            valid={this.state.validation}
            values={this.state.event}
            screens={this.state.jackpotScreens}
            orderLimitEnabled={this.context.config.order_limit_enabled}
            handleChange={this.handleChange}
            handleStep={this.handleStep}
          />
        );
      case "expenses":
        return (
          <Expenses
            handleChange={this.handleChange}
            handleStep={this.handleStep}
            handleSubmit={this.handleSubmit}
            setRules={this.handleRules}
            enableFixedExpenses={this.context.config.fixed_expenses_enabled}
            valid={this.state.validation}
            values={this.state.event}
          />
        );
      case "verify":
        return (
          <Verify
            values={this.state.event}
            nonProfits={this.state.nonProfits}
            games={this.state.games}
            campaigns={this.state.campaigns}
            pricingData={this.state.pricingData}
            customWebPricingEnabled={this.context.config.custom_web_pricing_enabled}
            pricepointLabelsEnabled={this.context.config.pricepoint_labels_enabled}
            xhrEventId={this.state.xhrEventId}
            dynamicPPTimeOverlap={this.state.dynamicPPTimeOverlap}
            calendarStartDateError={this.state.calendarStartDateError}
            NonAddOnEventList={this.state.NonAddOnEventList}
            config={this.context.config}
            handleStep={this.handleStep}
            handleSubmit={this.handleSubmit}
          />
        );
    }
  };
  render() {
    const { step, steps, isLoading, xhrStatus, xhrMessage, event } = this.state;
    const { config } = this.context;
    let newSteps = steps;
    if (config && config.raffle_num_import_enabled && event.is_import_raffle > 0) {
        newSteps = newSteps.filter(function (el) {
          return el['key'] !== 'sales' && el['key'] !== 'pricing' && el['key'] !== 'jackpot' && el['key'] !== 'expenses' && el != null;
        });
    }

    return (
      <Segment basic loading={isLoading}>
        <Step.Group fluid items={newSteps} />
        {this.showStep(step)}
        <ResponseMessage status={xhrStatus} message={xhrMessage} />
      </Segment>
    );
  }
}
EventForm.contextType = AppContext;

export default EventForm;
